// Vereditos das medicoes do app. Extraidos do App.js em
// 08/10/2026: sao as funcoes que escrevem as palavras que o
// usuario LE e sobre as quais ele age. Um erro de sinal aqui faz
// o app se elogiar sozinho, e nada o pegaria — por isso saem do
// componente e ganham teste de propriedade. Puras: recebem o
// objeto medido e devolvem { estado, txt, cor }.

export function vereditoScoresRegime(o) {
  if (!o || !o.nomes || !o.out)
    return { estado: "sem base", txt: "Sem registros ainda.", cor: "#6b7280" }
  const frases = []
  let comBase = 0, aFavor = 0, contra = 0
  Object.entries(o.nomes).forEach(([col, nome]) => {
    ["alta","baixa","lateral"].forEach(k => {
      const g = o.out[col] && o.out[col][k]
      if (!g || g.a.length < 5 || g.b.length < 5) return
      comBase++
      const ma = g.a.reduce((x,y)=>x+y,0)/g.a.length
      const mb = g.b.reduce((x,y)=>x+y,0)/g.b.length
      const rot = k === "alta" ? "em alta" : k === "baixa" ? "em baixa" : "de lado"
      if (Math.abs(ma-mb) >= 2) {
        if (ma > mb) aFavor++
        else contra++
        frases.push(nome + " " + (ma > mb ? "separa" : "separa ao contrário") + " com o ativo " + rot)
      }
    })
  })
  if (comBase === 0)
    return { estado: "sem base", txt: "Sem veredito: nenhuma combinação chegou a 5 análises com nota alta e 5 com nota baixa.", cor: "#6b7280" }
  if (frases.length === 0)
    return { estado: "não acrescenta", txt: "Até aqui, nenhuma das " + comBase + " combinações com base separou as notas.", cor: "#6b7280" }
  const estado = (aFavor > 0 && contra === 0) ? "acrescenta"
    : (contra > 0 && aFavor === 0) ? "ao contrário"
    : "não acrescenta"
  return { estado: estado, txt: "Até aqui: " + frases.join("; ") + ".", cor: "#9ca3af" }
}


export function vereditoPorRegime(o) {
  if (!o || !o.R) return { estado: "sem base", txt: "Sem registros ainda.", cor: "#6b7280" }
  const bons = ["alta","baixa","lateral"].filter(k => o.R[k] && o.R[k].tot >= 5)
  if (bons.length === 0)
    return { estado: "sem base", txt: "Sem veredito: nenhum regime chegou a 5 análises.", cor: "#6b7280" }
  let acima = 0, abaixo = 0
  const frases = bons.map(k => {
    const g = o.R[k]
    const ac = g.ok / g.tot * 100, bs = g.subiu / g.tot * 100
    const nome = k === "alta" ? "em alta" : k === "baixa" ? "em baixa" : "de lado"
    if (Math.abs(ac - bs) < 5) return "com o ativo " + nome + " não se separa da base"
    if (ac > bs) { acima++; return "com o ativo " + nome + " supera a base" }
    abaixo++
    return "com o ativo " + nome + " fica abaixo da base"
  })
  const estado = (acima > 0 && abaixo === 0) ? "acrescenta"
    : (abaixo > 0 && acima === 0) ? "ao contrário"
    : "não acrescenta"
  return { estado: estado, txt: "Até aqui, o Confluence " + frases.join("; ") + ".", cor: "#9ca3af" }
}


export function vereditoExaustao(o) {
  if (!o || o.cimaN === undefined)
    return { estado: "sem base", txt: "Sem registros ainda.", cor: "#6b7280" }
  if (o.cimaN < 5 || o.baixoN < 5) {
    const falta = o.cimaN < 5 && o.baixoN < 5
      ? "poucas análises de ativo subindo (RSI acima de 55) e de ativo caindo (RSI abaixo de 45)"
      : o.cimaN < 5
      ? "poucas análises de ativo subindo (RSI acima de 55): " + o.cimaN
      : o.baixoN === 0
      ? "nenhuma análise pegou ativo caindo (RSI abaixo de 45)"
      : "poucas análises de ativo caindo (RSI abaixo de 45): " + o.baixoN
    return { estado: "sem base", txt: "Sem veredito: " + falta + ".", cor: "#6b7280" }
  }
  const b = o.baseMed ?? 0
  const okCima = o.cimaMed < b, okBaixo = o.baixoMed > b
  if (okCima && okBaixo)
    return { estado: "acrescenta", txt: "Até aqui, a exaustão aponta na direção esperada — falta base para confirmar.", cor: "#22c55e" }
  if (!okCima && !okBaixo)
    return { estado: "ao contrário", txt: "Até aqui, a exaustão aponta ao CONTRÁRIO do esperado.", cor: "#ef4444" }
  return { estado: "não acrescenta", txt: "Até aqui, só um dos lados se comporta como esperado.", cor: "#f59e0b" }
}


export function vereditoContraBase(alta, altaOk, baixa, baixaOk, subiu, comparadas, nome) {
  const tot = (alta || 0) + (baixa || 0)
  if (!comparadas || tot < 20)
    return { estado: "sem base", curto: tot + " de 20 chamadas com direção", txt: "Sem veredito: " + tot + (tot === 1 ? " chamada" : " chamadas") + " com direção, abaixo das 20 que separam sinal de ruído.", cor: "#6b7280" }
  // Contra a CHANCE, e nao contra 50% nem contra a taxa de subida crua: cada
  // chamada de alta vale a taxa de subida da base e cada uma de baixa vale a
  // de queda. Sem esse peso, num periodo de alta com chamadas quase todas de
  // alta a taxa de acerto e a linha de base medem a mesma coisa.
  const pSubiu = subiu / comparadas
  const esp = alta * pSubiu + baixa * (1 - pSubiu)
  const obt = altaOk + baixaOk
  const d = (obt - esp) / tot * 100
  // Desvio padrao em acertos: cada chamada e um Bernoulli com p = a taxa do
  // seu proprio lado, e p*(1-p) da o mesmo valor nos dois lados, entao a
  // variancia total e tot * p * (1-p).
  const sd = Math.sqrt(tot * pSubiu * (1 - pSubiu))
  const z = sd > 0 ? (obt - esp) / sd : 0
  const mag = Math.abs(Math.round(d))
  if (Math.abs(d) < 5)
    return { estado: "não acrescenta", curto: "na chance", txt: "Até aqui, " + nome + " não acerta mais que a chance.", cor: "#6b7280" }
  // A diferenca existe, mas so vira veredito de DIRECAO quando passa de dois
  // desvios padrao. Abaixo disso ela cabe no acaso desta amostra, e afirmar
  // 'ao contrario' seria condenar com sinal fraco — o erro simetrico do que
  // esta regra evita do outro lado. Dois sigma e convencao, nao lei.
  if (Math.abs(z) < 2)
    return { estado: "não acrescenta",
             curto: mag + " pontos " + (d > 0 ? "acima" : "abaixo") + ", dentro do acaso",
             txt: "Até aqui, " + nome + " acerta " + mag + " pontos " + (d > 0 ? "acima" : "ABAIXO") + " da chance — mas isso cabe no que " + tot + " chamadas produzem por azar, " + Math.abs(z).toFixed(1) + " desvios padrão. Precisa repetir para valer.",
             cor: "#f59e0b" }
  if (d > 0)
    return { estado: "acrescenta", curto: "+" + mag + " pontos acima da chance", txt: "Até aqui, " + nome + " acerta " + mag + " pontos acima da chance, " + Math.abs(z).toFixed(1) + " desvios padrão além do acaso.", cor: "#22c55e" }
  return { estado: "ao contrário", curto: "-" + mag + " pontos abaixo da chance", txt: "Até aqui, " + nome + " acerta " + mag + " pontos ABAIXO da chance, " + Math.abs(z).toFixed(1) + " desvios padrão além do acaso.", cor: "#ef4444" }
}


export function vereditoSeparacao(o, nome) {
  if (!o || o.altoN === undefined || o.altoN < 5 || o.baixoN < 5)
    return { estado: "sem base", txt: "Sem veredito: ainda faltam medições nas faixas.", cor: "#6b7280" }
  if (o.altoMed === null || o.baixoMed === null)
    return { estado: "sem base", txt: "Sem veredito: faltam retornos medidos.", cor: "#6b7280" }
  const d = o.altoMed - o.baixoMed
  if (Math.abs(d) < 2)
    return { estado: "não acrescenta", txt: "Até aqui, " + nome + " não separa as faixas.", cor: "#6b7280" }
  if (d > 0)
    return { estado: "acrescenta", txt: "Até aqui, " + nome + " separa na direção esperada — falta base para confirmar.", cor: "#22c55e" }
  return { estado: "ao contrário", txt: "Até aqui, " + nome + " separa ao CONTRÁRIO do esperado.", cor: "#ef4444" }
}

// Agio e desagio do ETF: o decimo terceiro quesito. A regra foi
// pre-registrada em 31/10/2026, com a emenda do mesmo dia, antes de existir
// um unico retorno de 30 dias — os cortes abaixo nao foram escolhidos
// olhando resultado, porque nao havia resultado para olhar.
// Base minima: 20 leituras de cada lado em pelo menos 5 fundos.
// Invalida se a diferenca ficar abaixo de 1 ponto percentual, ou se menos de
// 70% dos fundos apontarem para o mesmo lado.
export function vereditoPremio(o) {
  if (!o || o.agioN === undefined)
    return { estado: "sem base", txt: "Sem veredito: a medição ainda não começou.", cor: "#6b7280" }
  if (o.tickersN < 5 || o.agioN < 20 || o.desagioN < 20)
    return { estado: "sem base", txt: "Sem veredito: a base mínima é 20 leituras de cada lado em 5 fundos.", cor: "#6b7280" }
  if (o.agioMed === null || o.desagioMed === null)
    return { estado: "sem base", txt: "Sem veredito: faltam retornos de 30 dias.", cor: "#6b7280" }
  const d = o.agioMed - o.desagioMed
  if (Math.abs(d) < 1)
    return { estado: "não acrescenta", txt: "Até aqui, o ágio não separa: a diferença é menor que 1 ponto percentual.", cor: "#6b7280" }
  if (o.concordTot > 0 && o.concordam / o.concordTot < 0.7)
    return { estado: "não acrescenta", txt: "Até aqui, a diferença aparece no total mas menos de 70% dos fundos apontam para o mesmo lado — é fundo puxando, não efeito.", cor: "#6b7280" }
  if (d > 0)
    return { estado: "acrescenta", txt: "Até aqui, o ágio antecede retorno maior que o deságio, na direção esperada.", cor: "#22c55e" }
  return { estado: "ao contrário", txt: "Até aqui, é o deságio que antecede retorno maior — o CONTRÁRIO do esperado.", cor: "#ef4444" }
}
